import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

/**
 * Executes a callback when the frontend route changes.
 *
 * The `callback` argument should have its reference memoized with useCallback.
 *
 * e.g.
 *
 * useCallbackOnRouteChange(
 *   useCallback(() => {
 *     setIsMenuOpen(false)
 *   }, [setIsMenuOpen])
 * )
 *
 * @param {Function} callback A function to execute when the route changes
 */
const useCallbackOnRouteChange = callback => {
  const history = useHistory()

  useEffect(() => {
    const unlisten = history.listen(({ action, location }) => {
      callback(action, location)
    })

    return () => unlisten()
  }, [history, callback])
}

export { useCallbackOnRouteChange }
